import { BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations
 * in app.module.ts file.
 */
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: '',
    // This is the ONLY mandatory field that you need to supply.
    authority: '',
    // Defaults to "https://login.microsoftonline.com/common"
    knownAuthorities: [],
    // Mark your B2C tenant's domain as trusted.
    redirectUri: '',
    // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
    postLogoutRedirectUri: '',
    // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    tokenRenewalOffsetSeconds: 180,
    loggerOptions: {
      // leaving values in to see what is being passed
      // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
      loggerCallback(_logLevel, _message) {
        // uncomment for debugging MSAL
        // console.log(_message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};
